import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Clock, CreditCard, Languages, MapPin, Briefcase } from 'lucide-react';
import { useLang } from '@/i18n/LanguageContext';

const ICONS = [Stethoscope, Clock, CreditCard, Languages, MapPin, Briefcase];
const ACCENTS = [
  'from-blue-600 to-blue-800',
  'from-amber-500 to-amber-700',
  'from-emerald-600 to-emerald-800',
  'from-indigo-600 to-indigo-800',
  'from-rose-500 to-rose-700',
  'from-sky-600 to-sky-800'
];

const WhyUs = () => {
  const { t } = useLang();
  return (
    <section id="why" className="relative py-20 md:py-28 bg-slate-50/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-14">
          <div className="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-[11px] font-bold uppercase tracking-[0.18em] mb-4">
            {t.why.kicker}
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            {t.why.title}
          </h2>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">{t.why.subtitle}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.why.features.map((f, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="group relative bg-white rounded-2xl p-6 md:p-7 border border-slate-200/80 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all overflow-hidden"
              >
                <div className={`absolute -top-12 -right-12 w-32 h-32 rounded-full bg-gradient-to-br ${ACCENTS[i % ACCENTS.length]} opacity-[0.06] group-hover:opacity-[0.12] transition-opacity blur-md`} />
                <div className={`relative w-12 h-12 rounded-xl bg-gradient-to-br ${ACCENTS[i % ACCENTS.length]} flex items-center justify-center shadow-md mb-5`}>
                  <Icon className="w-6 h-6 text-white" strokeWidth={2.2} />
                </div>
                <h3 className="relative text-lg font-bold text-slate-900 mb-2">{f.title}</h3>
                <p className="relative text-slate-600 leading-relaxed">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
